import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {
  AccionesTablaEnum,
  IAccionRowTabla,
  IActualizacionCeldaEditable,
  ICeldaEditable,
  IColumnaTabla,
  IColumnaTablaAvatar,
  IColumnaTablaEstado,
  IColumnaTablaImagen,
  TablaService,
  TipoColumnaEditableEnum,
  TipoColumnaTablaEnum
} from '@appNeo/neoShared/services/tabla/tabla.service';
import {MatTableDataSource} from '@angular/material/table';
import {MatDialog} from '@angular/material/dialog';
import {IFormInput} from '@appNeo/neoShared/helpers/interfaces/IForm-input';
import {FormTagEnum} from '@appNeo/neoShared/helpers/enums/FormTag.enum';
import {FormularioService} from '@appNeo/neoShared/services/formulario/formulario.service';
import {AccionDialogEnum} from '@appNeo/neoShared/helpers/enums/AccionDialog.enum';
import {FormularioFiltrosTablaService} from '@appNeo/neoShared/services/formulario-filtros-tabla/formulario-filtros-tabla.service';
import {BotonDesplegableService, IAccionesBotonDesplegable} from '@appNeo/neoShared/services/boton-desplegable/boton-desplegable.service';
import {LoremIpsum} from 'lorem-ipsum';
import {TagCampoEnum} from '@appNeo/neoShared/helpers/enums/TagCampo.enum';

export interface IRowTabla {
  imagen: IColumnaTablaImagen;
  titulo: string;
  autor: string;
  estado: IColumnaTablaEstado;
  avatar: IColumnaTablaAvatar;
  // GAL: IColumnaTablaEstado;
  // ENG: IColumnaTablaEstado;
  fechaPublicacion: string;
  activo: boolean;
  importe: ICeldaEditable;
  acciones: IAccionRowTabla [];
  id: string,
}

@Component({
  selector: 'neo-listado-ejemplo2',
  templateUrl: './listado-ejemplo2.component.html',
  styleUrls: ['./listado-ejemplo2.component.scss'],
  providers: [TablaService, FormularioService, FormularioFiltrosTablaService, BotonDesplegableService]
})
export class ListadoEjemplo2Component implements OnInit {
  @ViewChild('dialogCreacion') dialogCreacion: TemplateRef<any>;

  accionesMultiplesDesplegableTablaDemo: IAccionesBotonDesplegable[] =  [
    {id: 'publicar_seleccionados', iconoClase: '', texto: 'Publicar seleccionados'},
    {id: 'ocultar_seleccionados', iconoClase: '', texto: 'Ocultar seleccionados'},
    {id: 'eliminar_seleccionados', iconoClase: '', texto: 'Eliminar seleccionados'}
  ];

  columns: IColumnaTabla[] = [
    {key: 'select', nombre: '', tipo: TipoColumnaTablaEnum.Selector, ordenacion: false},
    {key: 'imagen', nombre: 'Imagen', tagCampo: TagCampoEnum.Imagen, tipo: TipoColumnaTablaEnum.Imagen, ordenacion: false},
    {key: 'titulo', nombre: 'Título', tipo: TipoColumnaTablaEnum.EnlacePrincipal, ordenacion: true},
    {key: 'autor', nombre: 'Autor', tipo: TipoColumnaTablaEnum.EnlaceSecundario, ordenacion: false},
    {key: 'importe', nombre: 'Importe', tipo: TipoColumnaTablaEnum.Editable, tipoColumnaEditable: TipoColumnaEditableEnum.Importe, ordenacion: true, unidad: '€', tagCampo: TagCampoEnum.Importe},
    {key: 'estado', nombre: 'Estado', tipo: TipoColumnaTablaEnum.Estado, ordenacion: true},
    {key: 'fechaPublicacion', nombre: 'Fecha Publicación', tipo: TipoColumnaTablaEnum.Fecha, ordenacion: true},
    {key: 'activo', nombre: 'Activo', tipo: TipoColumnaTablaEnum.Boolean, ordenacion: true},
    {key: 'acciones', nombre: 'Acciones', tipo: TipoColumnaTablaEnum.Acciones, ordenacion: false}
  ];

  data: IRowTabla[] = [];

  inputsFiltros: IFormInput[] = [
    {
      tag: FormTagEnum.select,
      label: 'Categoría',
      type: '',
      placeholder: 'Categoría',
      formControlName: 'idCategoria',
      obligatorio: false,
      validadores: [],
    },
    {
      tag: FormTagEnum.select,
      label: 'Subcategoría',
      type: '',
      placeholder: 'Subcategoría',
      formControlName: 'idSubCategoria',
      multiple: false,
      validadores: [],
    },
    {
      tag: FormTagEnum.date,
      label: 'Fecha Completa',
      type: 'fechaHora',
      placeholder: 'Fecha Completa',
      formControlName: 'fechaPublicacion',
      min: new Date(2021, 8, 1),
      max: new Date(2021, 11, 12),
      obligatorio: false,
      validadores: [],
    },
    {
      tag: FormTagEnum.date,
      label: 'Fecha Publicación',
      type: 'fecha',
      placeholder: 'Fecha Publicación',
      formControlName: 'fechaCortaPublicacion',
      min: new Date(2021, 8, 1),
      max: new Date(2021, 11, 12),
      obligatorio: false,
      validadores: [],
    },
    //TODO: Añadir select all??
    {
      tag: FormTagEnum.select,
      label: 'Idioma',
      type: '',
      placeholder: 'Idioma',
      formControlName: 'idIdioma',
      multiple: true,
      obligatorio: false,
      validadores: [],
    },
    {
      tag: FormTagEnum.estado,
      label: 'Estado',
      type: '',
      placeholder: 'Estado',
      formControlName: 'idEstado',
      multiple: true,
      obligatorio: false,
      validadores: [],
    }
  ];

  opcionesCategoria = [
      {
        'id': '1',
        'nombre': 'Categoría 1'
      },
      {
        'id': '2',
        'nombre': 'Categoría 2'
      },
      {
        'id': '3',
        'nombre': 'Categoría 3'
      },
      {
        'id': '4',
        'nombre': 'Categoría 4'
      },
      {
        'id': '5',
        'nombre': 'Categoría 5'
      },
    ];

  opcionesSubCategoria = [
    {
      'id': '1',
      'nombre': 'Sub Categoría 1'
    },
    {
      'id': '2',
      'nombre': 'Sub Categoría 2'
    },
    {
      'id': '3',
      'nombre': 'Sub Categoría 3'
    },
  ];

  opcionesIdioma = [
    {
      'id': '1',
      'nombre': 'Español'
    },
    {
      'id': '2',
      'nombre': 'Gallego'
    },
    {
      'id': '3',
      'nombre': 'Inglés'
    },
  ];

  opcionesEstado = [
    {
      'id': '1',
      'nombre': 'Publicada'
    },
    {
      'id': '2',
      'nombre': 'No publicada'
    },
  ];


  inputsCreacionEntrada: IFormInput[] = [
    {
      tag: FormTagEnum.input,
      label: 'Título',
      type: 'text',
      icon: 'title',
      placeholder: 'Título',
      formControlName: 'titulo',
      obligatorio: true,
      validadores: [],
    },
    {
      tag: FormTagEnum.importe,
      formControlName: 'importe',
      label: 'Importe',
      min: 0,
      type: 'number',
      icon: 'euro',
      placeholder: 'Importe',
      obligatorio: true,
      validadores: [],
      unidades: 'euros'
    },
  ];

  keyFiltrado = 'listadoEjemplo2';
  idTabla = 'tabla-listado-ejemplo2';

  valoresInicialesFiltradoTabla = {
    idCategoria: '1',
    idSubCategoria: '1',
    fechaPublicacion: '',
    fechaCortaPublicacion: '',
    idIdioma: ['1' , '2', '3'],
    idEstado: ['1', '2'],
    busqueda: '',
  };

  columnasFiltradoFecha = [];
  constructor(
    private tableService: TablaService,
    private dialog: MatDialog,
    private formularioService: FormularioService,
    private filtrosTablaService: FormularioFiltrosTablaService,
    private botonDesplegableService: BotonDesplegableService,
  ) {
    this.tableService.columnas = this.columns;
    this.mapearColumnasFiltroOfflineFecha();
    const loremIpsum = new LoremIpsum();
    const fechaMin = new Date(2021, 8, 23);
    const fechaMax = new Date(2021,  8, 23);
    for (let i = 1; i < 50; i++) {
      const rutaImagen = (i % 2 === 0) ? `https://picsum.photos/40/40?random=${i}` : '';
      let fecha = this.fechaAleatoria(fechaMin, fechaMax);
      this.data.push(
        {
          id: '1',
          imagen:  {src: rutaImagen, alt: 'Ejemplo'},
          avatar: {nombre: 'Nombre Apellidos', src: rutaImagen},
          // titulo: `Título: ${i}`,
          titulo: 'Lorem ipsum este es el texto muy lago que no es asi',
          autor: 'Administrador',
          estado: {iconoClase: 'icon-20 icon-ibm--checkmark--outline', color: '#00D385', nombre: 'Activo'},
          fechaPublicacion: fecha.toLocaleString(),
          activo: Boolean(Math.round(Math.random())),
          importe:  {
            nombre: Math.floor(Math.random() * (150)),
          },
          acciones: [
            {
              idAccion: AccionesTablaEnum.Editar,
              tooltip: 'Editar entrada',
              icono: true,
              iconClass: 'icon-20 icon-ibm--edit',
              disabled: false,
            },
            {
              idAccion: AccionesTablaEnum.Ocultar,
              tooltip: 'Ocultar entrada',
              icono: true,
              iconClass: 'icon-20 icon-ibm--view--off',
              disabled: false,
            },
            {
              idAccion: AccionesTablaEnum.Eliminar,
              tooltip: 'Eliminar entrada',
              icono: true,
              iconClass: 'icon-20 icon-ibm--trash-can text-danger',
              disabled: false,
            },
          ],
        },
      );
    }

    this.tableService.data =  new MatTableDataSource(this.data);
    this.tableService.total = this.data.length;
    this.inputsFiltros[0].datos = this.opcionesCategoria;
    this.inputsFiltros[1].datos = this.opcionesSubCategoria;
    this.inputsFiltros[4].datos = this.opcionesIdioma;
    this.inputsFiltros[5].datos = this.opcionesEstado;
    this.filtrosTablaService.inputsForm =  this.inputsFiltros;
  }

  ngOnInit(): void {
    this.subscriptionAccionLote();
  }

  mapearColumnasFiltroOfflineFecha() {
    this.columns.forEach(columnaTabla => {
      if (columnaTabla.tipo === TipoColumnaTablaEnum.Fecha || columnaTabla.tipo === TipoColumnaTablaEnum.Hora || columnaTabla.tipo === TipoColumnaTablaEnum.FechaHora ) {
        this.columnasFiltradoFecha[0] = columnaTabla.key;
      }
    });
  }

  fechaAleatoria(fechaInicio, fechaFin) {
    fechaInicio = fechaInicio.getTime();
    fechaFin = fechaFin.getTime();
    const fecha = new Date(fechaInicio + Math.random() * (fechaFin - fechaInicio));
    return fecha;
  }

  subscriptionAccionLote() {
    this.botonDesplegableService.accionSeleccionada$.subscribe(accionSeleccionada => {
      console.log('Se selecciona la acción en lote con el id: ', accionSeleccionada);
    });
  }

  get _accionDialog() {
    return AccionDialogEnum;
  }

  abrirDialogo(accion: AccionDialogEnum): void {
    switch (accion) {
      case AccionDialogEnum.Crear:
        this.dialog.open(this.dialogCreacion, {});
        this.formularioService.inputs = this.inputsCreacionEntrada;
        break;
    }
  }

  //TODO IMPLEMENTAR TRAS INTEGRACIÓN CON API
  aplicarFiltrosTablaOnline(entidadFiltrado: object) {
    console.log('OBJETO A FILTRAR: ', entidadFiltrado);
  }

  aplicarAccionMultipleSeleccion(dataAccionSeleccion: object){
    console.log('Accion multiple y elementos seleccionados: ', dataAccionSeleccion);
  }

  clickAccionRowTabla(datos) {
    console.log('Accion sobre fila ', datos);
  }

  accionCabeceraClick(datos) {
    console.log('Accion botonera cabecera', datos);
  }

  actualizacionCeldaEditable(actualizacion: IActualizacionCeldaEditable) {
    console.log('ACTUALIZACIÓN CAMBIO CELDA EDITABLE EN LISTADO EJEMPLO 1', actualizacion);
    let columnaKey = actualizacion.columnaKey;
    let row = actualizacion.row;
    let esColumnaEditable = this.columns.filter(columna => columna.tipo === TipoColumnaTablaEnum.Editable);
    if ( esColumnaEditable) {
      this.data.forEach(rowTablaAnterior => {
        if (rowTablaAnterior === row) {
          rowTablaAnterior[columnaKey].nombre = actualizacion.valorActualizado;
        }
      });
    }
  }
}
